// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__bd97m","load2":"Spinner_load2__ZPNni"};